var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 71,
    viewBox: "0 0 62 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1643:1086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.615 25.1699L23.695 70.4599",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.445 50.7906L16.575 46.1406",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.125 35.5801L22.015 39.4801L30.305 68.4101",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.305 23.1602L20.075 32.8102L31.845 29.2602",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.695 55.5598L61.555 45.5098",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.715 13.7402C55.715 20.6402 43.225 41.6802 43.225 41.6802C43.225 41.6802 30.725 20.6802 30.725 13.7402C30.725 10.425 32.042 7.24557 34.3862 4.90137C36.7304 2.55716 39.9098 1.24023 43.225 1.24023C46.5402 1.24023 49.7196 2.55716 52.0638 4.90137C54.408 7.24557 55.725 10.425 55.725 13.7402H55.715Z",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.555 13.7405C48.555 14.7971 48.2416 15.8299 47.6544 16.7083C47.0672 17.5866 46.2326 18.2709 45.2562 18.6748C44.2799 19.0787 43.2057 19.1839 42.1695 18.9771C41.1334 18.7702 40.1819 18.2608 39.4355 17.5129C38.6891 16.7651 38.1813 15.8126 37.9764 14.7761C37.7715 13.7396 37.8787 12.6655 38.2844 11.69C38.6901 10.7144 39.3761 9.88098 40.2555 9.29542C41.135 8.70986 42.1684 8.39842 43.225 8.4004C44.6395 8.40305 45.9952 8.96687 46.9945 9.96803C47.9938 10.9692 48.555 12.326 48.555 13.7405V13.7405Z",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.245 48.1602L54.805 57.1602",
    stroke: "#78264F",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1643:1086"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61.81,
    height: 70.8,
    fill: "white",
    transform: "translate(0.0950012)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.48888971.svg";
export { ForwardRef as ReactComponent };